import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NavigateEvaluationService } from '../navigate-evaluation.service';
import { EvaluationService } from '../shared/services/evaluationservice/evaluation.service';
import { DashboardService } from '../shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from '../shared/services/shared-mode.service';
import Swal from 'sweetalert2';
import { CommonModule, DatePipe } from '@angular/common';
import { AddService } from '../shared/services/userservices/add.service';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../shared/components/loader/loader.component';
@Component({
  selector: 'app-all-user-evaluation',
  templateUrl: './all-user-evaluation.component.html',
  styleUrl: './all-user-evaluation.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule,],
  providers: [DatePipe],
})
export class AllUserEvaluationComponent implements OnInit {
  [x: string]: any;
  public showSpinner = true;
  users: any[] = [];
  kps_points: any[] = [];
  inputValues: Record<number, { pm_values: string[]; kps_value: string[] }> = {};
  isUserInteracted = false;
  selectedMode: any
  user_role: any;
  errors: Record<number, boolean[]> = {};
  constructor(private router: Router,
    private navigationEvaluationService: NavigateEvaluationService,
    private evaluationService: EvaluationService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private datePipe: DatePipe,
    private addService: AddService,
  ) {

  }
  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
      this.showSpinner = false
    });
    this.isUserInteracted = false;
    this.getTabsData();
    this.user_detail();
    this.evaluation_points();
    const today = new Date();
    this.currentDateString = this.datePipe.transform(today, 'yyyy-MM-dd')!;
    this.selectedDate = this.currentDateString;
    this.onDateChange(this.currentDateString);

  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.role = this.userInfo.user_role.user_roles
      this.user_role = JSON.parse(this.role).role_type;
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.activeRoleId = this.userInfo?.employee_role_id
      this.showSpinner = false;
    })
  }
  setActiveRole(roleId: number) {
    this.activeRoleId = roleId;
    this.evaluation_points();

  }
  evaluation_points() {
    if (this.activeRoleId == undefined) {
      this.activeRoleId = 1
    } else {
      this.activeRoleId
    }
    this.evaluationService.getEvaluationAdmin(this.activeRoleId).then((value: any) => {
      if (value.success) {
        this.kps_points = value.data.kps_list;
        this.showSpinner = false;
        this.getallUsers();
      } else {
        console.error('Failed to fetch evaluation points:', value.message);
      }
    }).catch(error => {
      console.error('Error fetching evaluation points:', error);
    });
  }


  getallUsers() {
    this.showSpinner = true;
    this.assigndate
    if (this.activeRoleId == undefined) {
      this.activeRoleId = 1
    } else {
      this.activeRoleId
    }
    this.evaluationService.getAllUsers(this.activeRoleId, this.assigndate).then((value: any) => {
      if (value) {
        this.users = value.users;
        this.initializeInputValues();
        this.showSpinner = false;
      } else {
        console.error('No users found');
      }
    }).catch(error => {
      console.error('Error fetching users:', error);
    });

  }


  initializeInputValues() {
    this.users.forEach((user: any) => {
      this.inputValues[user.user.id] = {
        pm_values: [], // Initialize as an empty array
        kps_value: []  // Initialize as an empty array
      };

      // Populate pm_values and kps_value if available
      if (user.evaluations[0]) {
        if (user.evaluations[0].pm_values) {
          this.inputValues[user.user.id].pm_values = user.evaluations[0].pm_values.split(',');
        }
        if (user.evaluations[0].kps_value) {
          this.inputValues[user.user.id].kps_value = user.evaluations[0].kps_value.split(',');
        }
      }

      // Fill with empty strings if both values are absent
      const kpsLength = this.kps_points.length; // Assuming this.kps_points is populated
      this.inputValues[user.user.id].pm_values = this.inputValues[user.user.id].pm_values.length ?
        this.inputValues[user.user.id].pm_values : Array(kpsLength).fill('');
      this.inputValues[user.user.id].kps_value = this.inputValues[user.user.id].kps_value.length ?
        this.inputValues[user.user.id].kps_value : Array(kpsLength).fill('');
    });
  }

  showAlert(title: string) {
    Swal.fire({
      iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
      title: title,
      showConfirmButton: false,
      timer: 2000,
    });
  }
  totalPoints: Record<number, number> = {};

  onInputChange(userId: number, index: number, value: string, maxValue: string, isKps = false): void {
    if (!this.inputValues[userId]) {
      this.inputValues[userId] = {
        pm_values: [],
        kps_value: []
      };
    }

    const numericValue = Number(value);
    const maxNumericValue = maxValue ? parseFloat(maxValue.replace('%', '').trim()) : 0;

    if (!this.errors[userId]) {
      this.errors[userId] = [];
    }

    if (numericValue > maxNumericValue) {
      this.errors[userId][index] = true;
    } else {
      this.errors[userId][index] = false;
    }
    if (this.user_role === 'Team_Lead' || this.user_role === 'Admin_AND_Team_Lead') {
      this.inputValues[userId].kps_value[index] = value;
    } else {
      this.inputValues[userId].pm_values[index] = value;
    }


    this.calculateTotalPoints(userId);
  }



  calculateTLTotalPoints(userId: number): number {
    const kpsValues = this.inputValues[userId]?.kps_value || [];
    const totalKPSPoints = kpsValues.reduce((sum: number, value: string) => {
      const percentageValue = Number(value || 0);
      const points = (percentageValue / 100) * 10;
      return sum + points;
    }, 0);

    return parseFloat(Math.min(totalKPSPoints, 10).toFixed(1));
  }

  calculateAdminTotalPoints(userId: number): number {
    const pmValues = this.inputValues[userId]?.pm_values || [];
    const totalPMPoints = pmValues.reduce((sum: number, value: string) => {
      const percentageValue = Number(value || 0);
      const points = (percentageValue / 100) * 10;
      return sum + points;
    }, 0);

    return parseFloat(Math.min(totalPMPoints, 10).toFixed(1));
  }



  // onDateChange(date: string) {
  //   const selectedDateObj = new Date(date);
  //   const formatdate = this.datePipe.transform(selectedDateObj, 'yyyy-MM-dd HH:mm:ss')
  //   const month_int = selectedDateObj.getMonth() + 1;
  //   const month_year = selectedDateObj.getFullYear();
  //   const month_char = selectedDateObj.toLocaleString('default', { month: 'long' });
  //   this.month_int = month_int
  //   this.month_year = month_year
  //   this.month_char = month_char
  //   this.date = formatdate
  //   this.assigndate = this.datePipe.transform(formatdate, 'yyyy/MM/dd');
  //   this.getallUsers();

  // }




  // sendData() {
  //   this.showSpinner = true;
  //   let submissionData = this.users.map((user: any) => {
  //     const inputValues = this.inputValues[user.user.id];

  //     const pm_values = inputValues.pm_values || [];
  //     const kps_value = inputValues.kps_value || [];

  //     const pm_list = pm_values
  //       .map((value) => (value ? Number(value) : null))
  //       .filter((value): value is number => value !== null);
  //     const kps_list = kps_value
  //       .map((value) => (value ? Number(value) : null))
  //       .filter((value): value is number => value !== null);

  //     this.pm_rating = pm_list;
  //     this.kps_rating = kps_list;

  //     let pm_points = this.pm_rating.reduce((partial_sum1: number, a: number) => {
  //       return partial_sum1 + a;
  //     }, 0);
  //     let tl_points = this.kps_rating.reduce((partial_sum1: number, a: number) => {
  //       return partial_sum1 + a;
  //     }, 0);
  //     // Calculate total points
  //     let total_points_pm = pm_points > 0 ? pm_points / 10 : 0;
  //     let total_points_tl = tl_points > 0 ? tl_points / 10 : 0;


  //     // Prepare strings for further operations
  //     const numberOfZeros = this.pm_rating.length;
  //     let zeroString = Array(numberOfZeros).fill(0).join(',');
  //     let pmRatingString = this.pm_rating.join(',');
  //     let tmRatingString = this.kps_rating.join(',');

  //     if (this.user_role === 'Admin') {
  //       this.admin_points = total_points_pm;
  //       this.team_leadPoint = total_points_tl;
  //       this.admin_values = pmRatingString || zeroString;
  //       this.teamLeadvalues = tmRatingString || zeroString;
  //     } else {
  //       this.admin_points = total_points_pm;
  //       this.team_leadPoint = total_points_tl;
  //       this.admin_values = pmRatingString || zeroString;
  //       this.teamLeadvalues = tmRatingString || zeroString;
  //     }

  //     if (this.date === undefined) {
  //       Swal.fire({
  //         iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
  //         title: 'First Select Date For Add evaluations',
  //         showConfirmButton: false,
  //         timer: 2000,
  //       });
  //       this.showSpinner = false;
  //       return;

  //     }

  //     return {
  //       user_id: user.user.id,
  //       month_int: this.month_int,
  //       month_year: this.month_year,
  //       month_char: this.month_char,
  //       pm_values: this.admin_values,
  //       kps_value: this.teamLeadvalues,
  //       pm_points: this.admin_points,
  //       points: this.team_leadPoint,
  //       date: this.date,
  //       is_evaluation: this.publish ?? 0
  //     };
  //   });

  //   // Remove undefined entries from submissionData
  //   submissionData = submissionData.filter(item => item !== undefined);

  //  if(submissionData.length > 0){
  //   this.evaluationService.addBulkEvaluation(submissionData).then((value) => {
  //     this.showSpinner = false;
  //     if (value.success) {
  //       Swal.fire({
  //         iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="image">',
  //         title: 'Evaluation Added Successfully',
  //         showConfirmButton: false,
  //         timer: 2000,
  //       });
  //     } else {
  //       Swal.fire({
  //         iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
  //         title: 'Evaluation Add Failed',
  //         showConfirmButton: false,
  //         timer: 2000,
  //       });
  //     }
  //     window.location.reload()

  //   });
  //  }
  // }


  onDateChange(date: string) {
    if (!this.isUserInteracted) {
      this.isUserInteracted = true;
      this.processDateChange(date);
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the date. If Yes you lost your changes? ',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        // Process the date change when user confirms
        this.getallUsers();
        this.processDateChange(date);
      } else {
        // Process the date change when user cancels (keep the current date)
        this.processDateChange(this.selectedDate);
      }
    });
  }

  // Common date processing logic to update the values
  processDateChange(date: string) {
    const selectedDateObj = new Date(date);
    const formatdate = this.datePipe.transform(selectedDateObj, 'yyyy-MM-dd HH:mm:ss');
    const month_int = selectedDateObj.getMonth() + 1;
    const month_year = selectedDateObj.getFullYear();
    const month_char = selectedDateObj.toLocaleString('default', { month: 'long' });

    this.month_int = month_int;
    this.month_year = month_year;
    this.month_char = month_char;
    this.date = formatdate;
    this.assigndate = this.datePipe.transform(formatdate, 'yyyy/MM/dd');

  }



  sendData() {
    this.showSpinner = true;

    let submissionData = this.users.map((user: any) => {
      const inputValues = this.inputValues[user.user.id];
      const kpsLength = this.kps_points.length; // Assuming you have a predefined length

      // Get the pm_values and kps_value arrays, and handle missing values
      let pm_values = inputValues.pm_values || [];
      let kps_value = inputValues.kps_value || [];

      // Fill missing pm_values with '0' if the user has provided any values in the array
      if (pm_values.some(val => val)) {
        pm_values = pm_values.map(value => value || '0');
        // Ensure the array has the correct length
        while (pm_values.length < kpsLength) {
          pm_values.push('0');
        }
      }

      // Fill missing kps_value with '0' if the user has provided any values in the array
      if (kps_value.some(val => val)) {
        kps_value = kps_value.map(value => value || '0');
        // Ensure the array has the correct length
        while (kps_value.length < kpsLength) {
          kps_value.push('0');
        }
      }

      // If both pm_values and kps_value are empty or only consist of empty values, skip this user
      if (!pm_values.some(val => val) && !kps_value.some(val => val)) {
        return undefined; // Don't include this user in the submissionData
      }

      const pm_list = pm_values.map(Number);
      const kps_list = kps_value.map(Number);

      // Calculate points
      const pm_points = pm_list.reduce((sum, val) => sum + val, 0);
      const tl_points = kps_list.reduce((sum, val) => sum + val, 0);

      const total_points_pm = pm_points > 0 ? pm_points / 10 : 0;
      const total_points_tl = tl_points > 0 ? tl_points / 10 : 0;

      // Prepare data for submission
      const pmRatingString = pm_values.join(',');
      const kpsRatingString = kps_value.join(',');

      if (this.date === undefined) {
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
          title: 'First Select Date For Add evaluations',
          showConfirmButton: false,
          timer: 2000,
        });
        this.showSpinner = false;
        return;
      }

      return {
        user_id: user.user.id,
        month_int: this.month_int,
        month_year: this.month_year,
        month_char: this.month_char,
        pm_values: pmRatingString,
        kps_value: kpsRatingString,
        pm_points: total_points_pm,
        points: total_points_tl,
        date: this.date,
        is_evaluation: this.publish ?? 0,
      };
    });

    // Remove undefined entries from submissionData
    submissionData = submissionData.filter(item => item !== undefined);

    if (submissionData.length > 0) {
      this.evaluationService.addBulkEvaluation(submissionData).then((value) => {
        this.showSpinner = false;
        if (value.success) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="image">',
            title: 'Evaluation Added Successfully',
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image">',
            title: 'Evaluation Add Failed',
            showConfirmButton: false,
            timer: 2000,
          });
        }
        window.location.reload();
      });
    }
  }




  getTabsData() {
    this.showSpinner = true;
    this.addService.getStaticData().then((value: any) => {
      this.showSpinner = false;
      this.office_roles = value.data.officeRolesId
      this.office_roles_array = Object.entries(this.office_roles).map(([id, role_names]) => {
        return { id: Number(id), role_names };
      });

    });
  }

  goBack() {
    window.history.back();
  }


}
